import { render, staticRenderFns } from "./ReturnAuthorisationExpressForm.vue?vue&type=template&id=56a9a671&"
import script from "./ReturnAuthorisationExpressForm.vue?vue&type=script&lang=js&"
export * from "./ReturnAuthorisationExpressForm.vue?vue&type=script&lang=js&"
import style0 from "./ReturnAuthorisationExpressForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReturnAuthorisationExpressForm.vue"
export default component.exports